import { Button, Form, Input, Modal } from "antd";
import moment from "moment";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { getSingledayPartSchedule, updateSingledayPartSchedule } from "../../../redux/rtk/features/dayPartSchedule/dayPartSlice";
import BtnEditSvg from "../Button/btnEditSvg";

const DayHoursEdit = ({ data }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const { id } = useParams("id");

	const [loader, setLoader] = useState(false);

	const dispatch = useDispatch();

	const onFinish = async (values) => {
		setLoader(true);
		const resp = await dispatch(updateSingledayPartSchedule({ id, values }));

		if (resp.payload.message === "success") {
			setLoader(false);
			dispatch(getSingledayPartSchedule(id));
			setIsModalOpen(false); // Close the modal on success
		} else {
			setLoader(false);
		}
	};

	// Prefilled values from data
	const initialValues = {
		name: data?.name,
		date: moment(data?.date),
		fullDayHours: data?.fullDayHours || "", // Prefill or default to an empty string
		halfDayHours: data?.halfDayHours || "",
		shortLeave: data?.shortLeave || "",
	};

	const onFinishFailed = (errorInfo) => {
		toast.warning("Failed at updating Day Hours");
		setLoader(false);
	};

	const showModal = () => {
		setIsModalOpen(true);
	};

	const handleOk = () => {
		setIsModalOpen(false);
		setLoader(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
		setLoader(false);
	};

	return (
		<>
			<button onClick={showModal}>
				<BtnEditSvg size={20} />
			</button>
			<Modal
				title="Day Part Edit"
				open={isModalOpen}
				onOk={handleOk}
				onCancel={handleCancel}>
				<Form
					style={{ marginBottom: "50px" }}
					initialValues={initialValues} // Use prefilled values
					name="basic"
					labelCol={{
						span: 7,
					}}
					wrapperCol={{
						span: 12,
					}}
					onFinish={onFinish}
					onFinishFailed={onFinishFailed}
					autoComplete="off">
					<Form.Item
						style={{ marginBottom: "10px" }}
						label="Full Day Hours"
						name="fullDayHours"
						rules={[
							{
								required: true,
								message: "Please input Full Day Hours!",
							},
						]}>
						<Input />
					</Form.Item>

					<Form.Item
						style={{ marginBottom: "10px" }}
						label="Half Day Hours"
						name="halfDayHours"
						rules={[
							{
								required: true,
								message: "Please input Half Day Hours!",
							},
						]}>
						<Input />
					</Form.Item>

					<Form.Item
						style={{ marginBottom: "10px" }}
						label="Short Leave"
						name="shortLeave"
						rules={[
							{
								required: true,
								message: "Please input Short Leave!",
							},
						]}>
						<Input />
					</Form.Item>

					<Form.Item
						style={{ marginBottom: "10px" }}
						wrapperCol={{
							offset: 7,
							span: 12,
						}}>
						<Button
							type="primary"
							htmlType="submit"
							block
							loading={loader}>
							Update
						</Button>
					</Form.Item>
				</Form>
			</Modal>
		</>
	);
};

export default DayHoursEdit;
